import React from 'react';
import './Sidebar.css';

const steps = [
    { id: 1, label: 'Contact & Login Details', desc: "Enter contact information and login credentials.", icon: require("../assets/logo/contactLogo.png"), iconActive: require("../assets/logo/contactLogo.png") },
    { id: 2, label: 'Company Information', desc: "Set up your company’s profile.", icon: require("../assets/logo/companyLogo.png"), iconActive: require("../assets/logo/companyLogo.png") },
    { id: 3, label: 'Address & Confirmation', desc: "Add address details and verify", icon: require("../assets/logo/addressLogo.png"), iconActive: require("../assets/logo/addressLogo.png") },
];

export default function Sidebar({ activeStep }) {
    return (
        <aside className="sidebar">
            <div className='headerHolder'>
                {steps.map((s) => (
                    <div
                        key={s.id}
                        className={`sidebar__step ${activeStep === s.id ? 'active' : ''}`}
                    >
                        <div className="sidebar__icon">
                            <img src={activeStep === s.id ? s.icon : s.icon} alt={s.label} />
                        </div>
                        <div>
                            <div className="sidebar__label ${activeStep === s.id ? 'active' : ''}">{s.label}</div>
                            <div className="sidebar__desc">{s.desc}</div>
                        </div>
                    </div>
                ))}
            </div>
        </aside>
    );
}
